import { ITag } from './../../models/tag';
import { debounceTime, map, catchError } from 'rxjs/operators';
import { IMember, IMemberResult } from '../../models/member';
import { Injectable, OnInit } from '@angular/core';
import { DataService } from '../data-services/data.service';
import { Observable } from 'rxjs';
import { IOrganization } from '../../models/organization';
import { ILoginInformation } from '../../models/login-information';
import { IManualTicket, ITicket, ITransferDetail } from '../../models/ticket';
import { DetailTilesComponent } from '../../admin/detail-tiles/detail-tiles.component';

@Injectable({
  providedIn: 'root',
})
export class TicketService extends DataService<ITicket> implements OnInit {
  protected collectionname = 'ticket';
  selectedMember: IMemberResult;
  public organizationId: string;
  public currentOrganization: IOrganization;
  public organizations: Array<IOrganization>;

  loginUser: ILoginInformation;

  ngOnInit(): void {
    this.setCollectionName('ticket');
  }

  getTicket(campaignId: string, ticketId: string): Observable<ITicket> {
    const url = `${this.urlService.buildUrl(
      this.collectionname,
      'campaign'
    )}/${campaignId}/ticket-id/${ticketId}/ticket`;
    return this.http.get<ITicket>(`${url}`).pipe(
      map((item) => {
        this.setId(item);
        return item;
      }),
      catchError(this.errorMgmt)
    );
  }

  transfer(details: ITransferDetail, ticket: ITicket): Observable<ITicket> {
    const url = `${this.urlService.buildUrl(
      this.collectionname,
      ticket['_id']
    )}/transfer`;

    const body = {
      transferDetails: details,
      campaignId: ticket.campaignId,
      ticketId: ticket['_id'],
    };

    return this.http.post<ITicket>(`${url}`, body).pipe(
      map((item) => {
        this.setId(item);
        return item;
      }),
      catchError(this.errorMgmt)
    );
  }

  accept(ticket: ITicket): Observable<{ transferId: string; ticket: ITicket }> {
    const url = `${this.urlService.buildUrl(
      this.collectionname,
      ticket['_id']
    )}/accept`;

    const body = {
      campaignId: ticket.campaignId,
      ticketId: ticket['_id'],
    };

    return this.http
      .post<{ transferId: string; ticket: ITicket }>(`${url}`, body)
      .pipe(
        map((item) => {
          this.setId(item.ticket);
          return item;
        }),
        catchError(this.errorMgmt)
      );
  }

  cancelTicket(ticket: ITicket): Observable<ITicket> {
    const url = `${this.urlService.buildUrl(
      this.collectionname,
      ticket['_id']
    )}/cancel`;

    const body = {
      campaignId: ticket.campaignId,
      ticketId: ticket['_id'],
    };

    return this.http.post<ITicket>(`${url}`, body).pipe(
      map((item) => {
        this.setId(item);
        return item;
      }),
      catchError(this.errorMgmt)
    );
  }

  getTickets(): Observable<{ tickets: ITicket[]; transfers: ITicket[] }> {
    const url = `${this.urlService.buildUrl(this.collectionname, 'list')}`;
    return this.http
      .get<{ tickets: ITicket[]; transfers: ITicket[] }>(`${url}`)
      .pipe(
        map((data) => {
          data.tickets.map((item) => {
            this.setId(item);
          });

          data.transfers.map((item) => {
            this.setId(item);
          });

          return data;
        }),
        catchError(this.errorMgmt)
      );
  }

  getTicketsByCampaign(campaignId: string): Observable<ITicket[]> {
    const url = `${this.urlService.buildUrl(
      this.collectionname,
      campaignId,
      'campaign-tickets'
    )}`;
    return this.http.get<ITicket[]>(`${url}`).pipe(
      map((data) => {
        data.map((item) => {
          this.setId(item);
        });

        return data;
      }),
      catchError(this.errorMgmt)
    );
  }

  buildQRCodeString(ticket: ITicket): string {
    return `${ticket['_id']}|${ticket.campaignId}|${ticket.token}`;
  }

  scanTicket(qrString: string): Observable<ITicket> {
    const url = `${this.urlService.buildUrl(
      this.collectionname
    )}${qrString}/scan`;

    const body = { ticketValue: qrString };
    return this.http.post<ITicket>(`${url}`, body).pipe(
      map((item) => {
        this.setId(item);
        return item;
      })
      // catchError(this.errorMgmt)
    );
  }
  createManualTickets(item: IManualTicket): Observable<ITicket[]> {
    // console.log('$event', $event);
    const url = `${this.urlService.buildUrl(
      this.collectionname
    )}manual-tickets`;

    return this.http.post<ITicket[]>(`${url}`, item).pipe(
      map((items) => {
        items = items.map((item) => {
          this.setId(item);
          return item;
        });
        return items;
      })
      // catchError(this.errorMgmt)
    );
  }
  redeemTicket(id: string, token: string): Observable<ITicket> {
    const url = `${this.urlService.buildUrl(
      this.collectionname,
      id,
      'redeem'
    )}`;

    const body = {
      id,
      token,
    };

    return this.http.post<ITicket>(`${url}`, body).pipe(
      map((item) => {
        this.setId(item);
        return item;
      }),
      catchError(this.errorMgmt)
    );
  }

  updateTags(id: string, tags: ITag[]) {
    const url = `${this.urlService.buildUrl(this.collectionname, id, 'tags')}`;

    const body = {
      id,
      tags,
    };

    return this.http.put<ITicket>(`${url}`, body).pipe(
      map((item) => {
        this.setId(item);
        return item;
      }),
      catchError(this.errorMgmt)
    );
  }

  getReportLogo(): HTMLImageElement {
    var img = new Image();

    img.src = '/assets/images/logo.png';
    img.onload = ($event) => {
      // console.log('$event', $event);
    };

    return img;
  }
}
